module.exports = __webpack_public_path__ + "img/couponclass7rc4.607a5ee6.png";